<template>
<v-alert v-if="host && host._stamps>=stampmax && host._message" type="success" class="mx-3" icon="verified">
  {{host._message}} <br><br><b v-if="host._stamps < host._total">Nog {{host._stamps}} van de {{host._total}} stempels over.</b>
            </v-alert>
<v-lazy :value="true"
        :options="{
          threshold: 0
        }" v-else-if="host && showStamps"
        min-height="100"
      >
<v-card  @click="select(host)" v-bind="$attrs" min-height="50" :tile="compact">
  <v-card-title class="font-weight-bold text-h6 mb-0">
                  {{host.name}}</v-card-title>
          
            <v-alert v-if="host._stamps>=stampmax" type="success" class="mx-3" icon="verified">
              Je hebt {{cards > 1 ? cards + 'x' : ''}} een volle kaart en krijgt een extra snack of drankje bij je volgende bestelling.
            </v-alert>
            <v-card-text>
                     <v-rating class="do-wrap"
                          :value="host._stamps"
                          :length="stampmax"
                          readonly
                        >
                          <template v-slot:item="props">
                            <v-divider v-if="props.index > 0 && props.index % stampmax == 0" class="my-3"></v-divider>
                            <stamp
                                  :value="{stamp: props.isFilled ? host.stamp || host.logo : '/img/stamp-empty.png'}"
                                  :empty="!props.isFilled"
                                  :text="host.name"
                                >
                                </stamp>
                            <!--v-icon v-if="false"
                              :color="props.isFilled ? 'success' : ''"
                            >verified</v-icon-->
                          </template>
                        </v-rating><br>
                        <div v-if="host._stamps > stampmax" class="caption float-right">{{host._stamps}} stempels</div><br>
                   </v-card-text>
</v-card>
</v-lazy>
<v-list-item v-else-if="host && compact" @click="select(host)" v-bind="$attrs">
  <v-list-item-avatar v-if="host.logo"><v-img :src="host.logo"></v-img></v-list-item-avatar>
  <v-list-item-content>
      <v-list-item-title>{{host.name}}</v-list-item-title>
      <v-list-item-subtitle v-if="!host.type || host.type.length==0">Nog niet actief</v-list-item-subtitle>
      <v-list-item-subtitle v-else v-html="opentext"></v-list-item-subtitle>
  </v-list-item-content>
  <v-list-item-action v-if="host.type">
            <v-icon v-for="type in host.type.filter(t=>$config.menu[t])" :color="dark? null : 'primary'" :key="type" v-text="$config.menu[type].icon"></v-icon>
  </v-list-item-action>
</v-list-item>
<v-card v-else-if="host" @click="select(host)" v-bind="$attrs" min-height="50" 
:disableds="!allowOrder && !search" :color="compact ? 'transparent' : null">
       
              <v-img v-if="!compact && banner"
              :src="banner" 
                class="white--text py-3 align-end text-left pb-3"
               height="130"
              >
              <div class="delivery-banner rounded-lg mx-3 pa-2 text-center caption" v-if="warning" v-text="warning"></div>
            <v-avatar class="ml-3" color="white">
            <v-img :src="host.logo"></v-img>
          </v-avatar>
                                                    
                <!--v-card-subtitle v-if="host._address" v-text="host._address.name" class="justify-center mt-0 pt-0"></v-card-subtitle>    
                <v-btn rounded color="primary" large class="mt-3"  @click.stop="goto(host)">Bestellen</v-btn-->
                <slot></slot>
            </v-img>
      <v-avatar class="ml-3 float-left mt-3 mr-3" color="white" v-if="compact">
            <v-img :src="host.logo"></v-img>
          </v-avatar>
            <v-card-title class="font-weight-bold text-h6 mb-0" :class="{'pl-0' : compact}">
                  {{host.name}}
                  
                  <v-spacer></v-spacer>
                   <v-icon v-if="favorite" :color="dark? null : 'primary'" class="ml-2">favorite</v-icon>
                   <template v-if="host.type && false">
                   <v-icon v-for="type in host.type.filter(t=>$config.menu[t])" :color="dark? null : 'primary'" :key="type" v-text="$config.menu[type].icon"></v-icon>
                   </template>
            </v-card-title>
             <v-card-subtitle class="pt-0"><span v-if="showCity && host._address" class="font-weight-bold">{{host._address.city}}: </span>
             <span v-if="host.type && host.type.length>0" v-text="arrayToSentence(host.type.filter(t=>$config.menu[t]).map(t=>$config.menu[t].title))"></span></v-card-subtitle>
             <v-card-subtitle v-if="!host.type || host.type.length==0">Nog niet actief</v-card-subtitle>
            <v-card-subtitle v-else v-html="opentext" class="pt-0"></v-card-subtitle>
           
          <!--v-card-text v-if="!compact && host.description" v-html="description" @click.stop="viewMore=!viewMore"></v-card-text-->
            
            <v-card-text v-if="!compact">
              <external-link v-if="host._address && showAddress" v-model="host._address.name" :label="host._address.name" icon="store" location dense class="ml-3"></external-link>  
              <external-link v-if="host.phone" v-model="host.phone" :label="host.phone" icon="phone" phone dense class="mr-2"></external-link>
              <external-link v-if="host.order && host.order.wait" icon="update" :label="host.order.wait + ' min'" dense class="mr-2"></external-link>
              <external-link v-if="distance>0 || host.price>0" icon="pin_drop" dense class="mr-2">
                {{distance}} km<template v-if="host.allow"> | {{host.price | toCurrency}}</template>
              </external-link>
              <external-link v-if="host.delivery && host.delivery.deliver && host.delivery.wait && host.allow" icon="delivery_dining" :label="host.delivery.wait + ' min'" dense></external-link>
              <slot></slot>
            </v-card-text>
           
            <slot name="actions" v-bind:allow="allow"></slot>
           
  </v-card>
                                            
</template>
<script>
import cardItem from '@/modules/cardItem'
import timeTable from '@/modules/timeTable'
import externalLink from '@/components/externalLink'
import stamp from "@/components/stamp";
export default {
  mixins: [cardItem, timeTable],
   components:{externalLink, stamp},
   props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    address: {
      type: Object,
      default: function () {
        return null
      },
    },
    distance: {
        type: Number,
        default: function () {
          return null
        },
      },
      showStamps:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      showAddress:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      showCity:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      dark:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      deliver:{
        type: Boolean,
        default: function () {
          return false
        },
      },
       search:{
        type: Boolean,
        default: function () {
          return false
        },
      },
      compact:{
        type: Boolean,
        default: function () {
          return false
        },
      }
   },
  data: () => ({
     viewMore:false
  }),
  computed: {
    favorite:{
      get(){
        return this.host._favorite
      },
      set(value){
        this.host._favorite = value
      }
    },
    stampmax(){
      if (this.host.order && this.host.order.stampmax) return this.host.order.stampmax
      return this.$config.stamps.max
    },
      cards(){
        if (!this.stampmax>0) return 0
        return Math.floor(this.host._stamps/this.stampmax)
      },
    banner(){
      //return '/bg-card.png'
      return this.host.banner
    },
    color(){
      if (this.host.color && this.host.color.includes('#')) return this.host.color 
      if (!this.host.type || !this.host.type[0]) return '#000000'
      return this._config('menu',this.host.type[0]).color || '#000000'
    },
    allowDeliver(){
      if (this.host.delivery && this.host.delivery.deliver==true) return true
      if (this.host.deliver ===true) return true
      return false
    },
    allowOrder(){
      if (this.host.order && this.host.order.allow!==false) return  true
      if (this.host.order===true) return  true
      return false
    },
    allow(){
      return !this.opentext.includes('Gesloten voor vandaag')
    },
    warning(){
      if (this.host.closed===true) return 'Gesloten voor vandaag'
      if (this.opentext.includes('Gesloten') && this.opentext.includes('Morgen')) return 'Gesloten'
      if (this.opentext.includes('Gesloten')) return 'Alvast bestellen'
      if (!this.allowDeliver) return 'Alleen afhalen'
      if (!this.allowOrder) return 'Niet afhalen'
      if (!this.address || !this.address.zipcode) return false
      if (this.host.regions.map(r=>r.zipcode).includes('#' + this.address.zipcode.substring(0,4))) return 'Wegens drukte tijdelijk geen bezorging op: ' + this.address.name
      return false
    },
    description(){
      if (!this.host.description) return null
      if (!this.viewMore) {
        let d = this.host.description.slice(0, 100)
        if (d.length==200) d += ' <b>...</b>'
        return d
      }
      return this.host.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    host: {
        get: function() {
          return this.value;
        },
        set: function(value) {
          this.$emit('input', value)
        }
    },
    
  },
  mounted () {
  },
watch: {
    
},
methods: {
   select(host){
     this.$emit('select', host)
    //this.setHost(host)
    //this.$router.push({'path' : "/" + host._id})
  },
  goto(host){
    this.$router.push({'path' : "/" + host._id})
  },
  arrayToSentence (arr) {
    
    if (arr.length==0) return ''
      if (arr.length==1) return arr[0]
      var last = arr.pop();
      return arr.join(', ') + ' en ' + last;
  }
  },

}

</script>
<style>
.delivery-banner{
  background: RGBA(0,0,0,0.7)
}
</style>